// トークOGP情報
export class TalkOgp {
  constructor(
    public title: string,
    public description: string,
    public image: string,
    public url: string,
  ) {}
}
